const ReleaseStatus = { TBA: 'TBA', TBD: 'TBD', NA: 'N/A', Live: 'Live', Released: 'Released' };

export default ReleaseStatus;

export const BrandGroup = { All: '0', Other: '9' };

export const AvailabilityNames = ['All releases', 'With guides', 'Active raffles'];

export const ReleasesPerPage = 16;
